<template>
  <div id="app" :class="{ 'scrollbarNone': isPhone }">
    <router-view v-if="isRouterAlive" />
    <div class="app-loading" v-else>
      <div class="loading-theme"></div>
      <div class="loading-line">
        <span :style="{ 'width': appNum + '%' }"></span>
      </div>
      <div class="jind">{{ appNum }}%</div>
    </div>
  </div>
</template>

<script>
import { is_mobile } from "./Toolset";
import { wxShare } from "./wxShare";
export default {
  name: "App",
  provide() {
    return {
      reload: this.reload,
    };
  },
  data: function () {
    return {
      isRouterAlive: true,
      isVideo: true,
      // videoBG: document.getElementById("videoBG"),
      isMobile:
        /phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone/i,
      winHeight: window.innerHeight,
      winNum: 1,
      count: 0,
      count2: 0,
      appNum: 0,
      appTime: null,
      appUser: {
        posterType: false,
        posterImg: "https://oss.eventnet.cn/H5/icon/seize.png",
      },
      countdownPoster: null,
      isPoster: false,
      uuidKey: "",
      slideDown: false,
      isPhone: false,
      isPc: true,
    };
  },
  created() {
    // const THAT = this;
    // THAT.appLoading();
  },
  computed: {
    /* eslint-disable */
    /* eslint-enable */
  },
  watch: {},
  mounted() {
    const THAT = this;
    if (is_mobile()) {
      THAT.preload(); // 图片预加载
      THAT.isPhone = true;
      THAT.isPc = false;
      // console.log('😁手机端 ===>>>', is_mobile(), window.location.href);
      wxShare({
        title: "挑战边界 - 72小时行动",
        desc: "让我们直面「边界」开始挑战！",
        link: "https://h5.eventnet.cn/72Hours_one/",
        logo: "https://oss.eventnet.cn/H5/72Hours/wxlogo.jpg",
      });
    } else {
      THAT.isPc = true;
      THAT.preload2();
    }
    // let routerName = THAT.$router.history.current.name;
    // console.log('😀 路由 =====>>>>>', routerName);
    // if (routerName == 'Index' || routerName == 'Home') {
    //     THAT.slideDown = true;
    // } else {
    //     THAT.slideDown = false;
    // }
    // window.addEventListener('scroll', THAT.handleScroll, true)
  },
  methods: {
    // handleScroll() {
    //     const THAT = this;
    //     var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.getElementById('app').scrollTop;
    //     if (scrollTop >= 1) {
    //         THAT.slideDown = false;
    //         if (scrollTop == 411) THAT.slideDown = true;
    //     }
    //     // console.log('轨道条：', scrollTop)
    // },
    closePoster() {
      const THAT = this;
    },
    appLoading() {
      const THAT = this;
      THAT.appTime = setInterval(() => {
        THAT.appNum += 1;
        // $('.jind').text(gvt + '%');
        // $('.jdt').css('width', (THAT.appNum * 100 / 200) + '%');
        if (THAT.appNum >= 100) {
          clearInterval(THAT.appTime);
          THAT.appTime = null;
          THAT.isRouterAlive = true;
        }
      }, 10);
    },
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
    preload() {
      const vUrl = "https://oss.eventnet.cn/H5/72Hours/";
      let vImg = [
        "https://oss.eventnet.cn/H5/icon/seize.png",
        vUrl + "img/bg-2.jpg",
        vUrl + "img/logo.png",
        vUrl + "img/72-hours3.png",
        vUrl + "img/slogan2.png",
        vUrl + "img/count-bg.png",
        vUrl + "img/count-down.png",
        vUrl + "img/btn-challenge.png",
        vUrl + "img/challenge-theme.png",
        vUrl + "img/challenge-track.png",
        vUrl + "image/220429/agenda-750x2.png",
        vUrl + "image/220426/6.png",
        vUrl + "image/220426/7.png",
        vUrl + "image/220429/5.png",
        vUrl + "image/220426/9.png",
        vUrl + "image/220426/10.png",
        vUrl + "img/btn-submit.png",
        vUrl + "img/72-bottom.png",
        vUrl + "img/bg-page-2.jpg",
        vUrl + "img/add.png",
        vUrl + "img/input-box.png",
        vUrl + "img/btn-game.png",
        vUrl + "img/s-success.png",
        vUrl + "img/page-bottom.png",
        vUrl + "img/track-complete.png",
        vUrl + "img/track-creative.png",
        vUrl + "img/textarea-box.png?v=220424",
        vUrl + "img/btn-image.png",
        vUrl + "img/btn-image2.png",
        vUrl + "img/btn-game.png",
        vUrl + "img/page-bottom-3.png",
        vUrl + "img/textarea-box2.png",
        vUrl + "img/btn-upload.png",
        vUrl + "pc/btn-upload2.png",
        vUrl + "img/success.png",
        vUrl + "img/success.png",
        "https://oss2.eventnet.cn/20220429-72Hours/ce5eb380-c81f-4faa-9bc6-033ca9721.jpg",
        "https://oss2.eventnet.cn/20220429-72Hours/fa548cb3-0d7a-4c61-a9d7-ce40621d2.jpg",
        "https://oss2.eventnet.cn/20220429-72Hours/eccca732-ab5f-4614-8fcf-aed8dafa3.jpg",
        "https://oss2.eventnet.cn/20220429-72Hours/6a443821-797e-4aa9-8441-7bd8b3614.jpg",
        "https://oss2.eventnet.cn/20220429-72Hours/eda9b163-75d1-4b1b-89b9-1c50903a5.jpg",
        "https://oss2.eventnet.cn/20220429-72Hours/8099729d-9441-4ae5-9d75-a9fcd347mmexport1651481199445.png",
        "https://oss2.eventnet.cn/20220429-72Hours/748da8a6-12cb-45e2-b93e-22ee29bftjsk.jpg",
        "https://oss2.eventnet.cn/20220429-72Hours/c/cc1.png",
        "https://oss2.eventnet.cn/20220429-72Hours/c/cc2.jpg",
        "https://oss2.eventnet.cn/20220429-72Hours/1/1.jpg",
        "https://oss2.eventnet.cn/20220429-72Hours/1/2.jpg",
        "https://oss2.eventnet.cn/20220429-72Hours/1/3.jpg",
        "https://oss2.eventnet.cn/20220429-72Hours/1/4.jpg",
        "https://oss2.eventnet.cn/20220429-72Hours/1/5.jpg",
        "https://oss2.eventnet.cn/20220429-72Hours/1/6.jpg",
        "https://oss2.eventnet.cn/20220429-72Hours/1/7.jpg",
        "https://oss2.eventnet.cn/20220429-72Hours/2/1.png",
        "https://oss2.eventnet.cn/20220429-72Hours/2/2.jpg",
        "https://oss2.eventnet.cn/20220429-72Hours/3/1.jpg",
        "https://oss2.eventnet.cn/20220429-72Hours/3/2.jpg",
        "https://oss2.eventnet.cn/20220429-72Hours/3/3.jpg",
        "https://oss2.eventnet.cn/20220429-72Hours/3/4.jpg",
        "https://oss2.eventnet.cn/20220429-72Hours/3/5.jpg",
        "https://oss2.eventnet.cn/20220429-72Hours/4/1.png",
        "https://oss2.eventnet.cn/20220429-72Hours/4/2.png",
        "https://oss2.eventnet.cn/20220429-72Hours/4/3.png",
        "https://oss2.eventnet.cn/20220429-72Hours/4/4.png",
        "https://oss2.eventnet.cn/20220429-72Hours/5/1.png",
        "https://oss2.eventnet.cn/20220429-72Hours/5/2.jpg",
        "https://oss2.eventnet.cn/20220429-72Hours/5/3.jpg",
        "https://oss2.eventnet.cn/20220429-72Hours/5/4.jpg",
        "https://oss2.eventnet.cn/20220429-72Hours/5/5.jpg",
        "https://oss2.eventnet.cn/20220429-72Hours/6/1.png",
        "https://oss2.eventnet.cn/20220429-72Hours/6/2.png",
        "https://oss2.eventnet.cn/20220429-72Hours/6/3.png",
        "https://oss2.eventnet.cn/20220429-72Hours/6/4.png",
        "https://oss2.eventnet.cn/20220429-72Hours/7/1.png",
        "https://oss2.eventnet.cn/20220429-72Hours/7/2.jpg",
        "https://oss2.eventnet.cn/20220429-72Hours/7/3.jpg",
        "https://oss2.eventnet.cn/20220429-72Hours/7/4.jpg",
        "https://oss2.eventnet.cn/20220429-72Hours/7/5.jpg",
      ];
      for (let img of vImg) {
        let image = new Image();
        image.src = img;
        image.onload = () => {
          this.count++;
        };
      }
    },
    preload2() {
      const vUrl = "https://oss.eventnet.cn/H5/72Hours/";
      let vImg = [
        vUrl + "pc/bg.jpg",
        vUrl + "pc/logo.png",
        vUrl + "pc/72-hours.png",
        vUrl + "pc/slogan2.png",
        vUrl + "pc/count-bg.png",
        vUrl + "pc/count-down.png",
        vUrl + "pc/btn-challenge.png",
        vUrl + "pc/challenge-theme.png",
        vUrl + "pc/challenge-track.png",
        vUrl + "image/220429/agenda-1920x2.png",
        vUrl + "image/220426/1.png",
        vUrl + "image/220429/4.png",
        vUrl + "image/220426/3.png",
        vUrl + "image/220426/4.png",
        vUrl + "image/220426/5.png",
        vUrl + "pc/btn-submit.png",
        vUrl + "pc/72-bottom.png",
        vUrl + "pc/bg-page2.jpg",
        vUrl + "img/input-box.png",
        vUrl + "img/add.png",
        vUrl + "img/btn-game.png",
        vUrl + "img/s-success.png",
        vUrl + "pc/page-bottom.png",
        vUrl + "img/track-complete.png",
        vUrl + "img/track-creative.png",
        vUrl + "img/textarea-box.png?v=220424",
        vUrl + "pc/textarea-box2.png",
        vUrl + "img/btn-image.png",
        vUrl + "img/btn-image2.png",
        vUrl + "pc/btn-game.png",
        vUrl + "pc/page-bottom.png",
        vUrl + "pc/form-disk.png",
        vUrl + "pc/form-input.png",
        vUrl + "pc/btn-upload.png",
        vUrl + "pc/btn-upload2.png",
        vUrl + "img/success.png",
        "https://oss2.eventnet.cn/20220429-72Hours/ce5eb380-c81f-4faa-9bc6-033ca9721.jpg",
        "https://oss2.eventnet.cn/20220429-72Hours/fa548cb3-0d7a-4c61-a9d7-ce40621d2.jpg",
        "https://oss2.eventnet.cn/20220429-72Hours/eccca732-ab5f-4614-8fcf-aed8dafa3.jpg",
        "https://oss2.eventnet.cn/20220429-72Hours/6a443821-797e-4aa9-8441-7bd8b3614.jpg",
        "https://oss2.eventnet.cn/20220429-72Hours/eda9b163-75d1-4b1b-89b9-1c50903a5.jpg",
        "https://oss2.eventnet.cn/20220429-72Hours/8099729d-9441-4ae5-9d75-a9fcd347mmexport1651481199445.png",
        "https://oss2.eventnet.cn/20220429-72Hours/748da8a6-12cb-45e2-b93e-22ee29bftjsk.jpg",
        "https://oss2.eventnet.cn/20220429-72Hours/c/cc1.png",
        "https://oss2.eventnet.cn/20220429-72Hours/c/cc2.jpg",
        "https://oss2.eventnet.cn/20220429-72Hours/1/1.jpg",
        "https://oss2.eventnet.cn/20220429-72Hours/1/2.jpg",
        "https://oss2.eventnet.cn/20220429-72Hours/1/3.jpg",
        "https://oss2.eventnet.cn/20220429-72Hours/1/4.jpg",
        "https://oss2.eventnet.cn/20220429-72Hours/1/5.jpg",
        "https://oss2.eventnet.cn/20220429-72Hours/1/6.jpg",
        "https://oss2.eventnet.cn/20220429-72Hours/1/7.jpg",
        "https://oss2.eventnet.cn/20220429-72Hours/2/1.png",
        "https://oss2.eventnet.cn/20220429-72Hours/2/2.jpg",
        "https://oss2.eventnet.cn/20220429-72Hours/3/1.jpg",
        "https://oss2.eventnet.cn/20220429-72Hours/3/2.jpg",
        "https://oss2.eventnet.cn/20220429-72Hours/3/3.jpg",
        "https://oss2.eventnet.cn/20220429-72Hours/3/4.jpg",
        "https://oss2.eventnet.cn/20220429-72Hours/3/5.jpg",
        "https://oss2.eventnet.cn/20220429-72Hours/4/1.png",
        "https://oss2.eventnet.cn/20220429-72Hours/4/2.png",
        "https://oss2.eventnet.cn/20220429-72Hours/4/3.png",
        "https://oss2.eventnet.cn/20220429-72Hours/4/4.png",
        "https://oss2.eventnet.cn/20220429-72Hours/5/1.png",
        "https://oss2.eventnet.cn/20220429-72Hours/5/2.jpg",
        "https://oss2.eventnet.cn/20220429-72Hours/5/3.jpg",
        "https://oss2.eventnet.cn/20220429-72Hours/5/4.jpg",
        "https://oss2.eventnet.cn/20220429-72Hours/5/5.jpg",
        "https://oss2.eventnet.cn/20220429-72Hours/6/1.png",
        "https://oss2.eventnet.cn/20220429-72Hours/6/2.png",
        "https://oss2.eventnet.cn/20220429-72Hours/6/3.png",
        "https://oss2.eventnet.cn/20220429-72Hours/6/4.png",
        "https://oss2.eventnet.cn/20220429-72Hours/7/1.png",
        "https://oss2.eventnet.cn/20220429-72Hours/7/2.jpg",
        "https://oss2.eventnet.cn/20220429-72Hours/7/3.jpg",
        "https://oss2.eventnet.cn/20220429-72Hours/7/4.jpg",
        "https://oss2.eventnet.cn/20220429-72Hours/7/5.jpg",
      ];
      for (let img of vImg) {
        let image = new Image();
        image.src = img;
        image.onload = () => {
          this.count2++;
        };
      }
    },
    CanvasScaleToWindow() {
      const THAT = this;
      if (!THAT.isMobile.test(navigator.userAgent.toLowerCase())) {
        document.getElementById("app").style.height = "1480px";
        document.body.style.cssText = `display:block;width:750px;height:1480px;margin:0 auto;transform:scale(${
          THAT.winHeight / 1480
        });transform-origin:center top;`;
      }
    },
  },
};
</script>

<style lang="scss">
@font-face {
  font-family: "DellReplica-Light";
  src: url("https://oss.eventnet.cn/H5/72Hours/font/DellReplica-Light.ttf");
}

@font-face {
  font-family: "MYuenPRC-Light";
  src: url("https://oss.eventnet.cn/H5/72Hours/font/MYuenPRC-Light.ttf");
}

@font-face {
  font-family: "MYuenPRC-SemiBold";
  src: url("https://oss.eventnet.cn/H5/72Hours/font/MYuenPRC-SemiBold.ttf");
}

html,
body {
  font-family: "MYuenPRC-SemiBold", "Avenir", Helvetica, Arial, sans-serif;
}

.MYuenPRCLight {
  font-family: "MYuenPRC-Light" !important;
}

#app {
  position: relative;
  width: 100%;
  height: 100%;
  background: #00036b;
  overflow-y: scroll;
  overflow-x: hidden;
  margin: auto;
  font-size: 26px;
  font-family: "MYuenPRC-SemiBold", "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #fff;

  .app-loading {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1000;
    width: 100%;
    height: 100%;
    background: #00036b;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-bottom: 120px;

    .loading-theme {
      width: 400px;
      height: 144px;
      background: url("https://oss.eventnet.cn/H5/72Hours/img/slogan.png") top
        no-repeat;
      background-size: 400px 465px;
    }

    .loading-line {
      position: relative;
      width: 420px;
      height: 15px;
      // border: solid 3px #b5bbc3;
      margin-top: 100px;
      margin-bottom: 20px;
      overflow: hidden;

      span {
        position: absolute;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        display: block;
        width: 100%;
        height: 100%;
        background-color: #fff;
      }
    }
  }
}

.scrollbarNone::-webkit-scrollbar {
  display: none;
}

.w218 {
  width: 218px !important;
}

/*  */
@keyframes breathingAni {
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.05);
  }

  100% {
    transform: scale(1);
  }
}

.breathingTo {
  animation: breathingAni 3s infinite linear;
}

@keyframes rotateAni {
  0% {
    transform: rotate(0deg);
  }

  50% {
    transform: rotate(180deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.rotateTo::before {
  animation: rotateAni 3s infinite linear;
}

//
.el-upload-list {
  display: none;
}

/* Swiper轮播-Pagination */
.swiper-slide {
  overflow: hidden !important;
}

.swiper-pagination-bullet {
  width: 15px !important;
  height: 15px !important;
  margin: 5px;
}

.swiper-pagination-bullet-active {
  background: #27e7dc !important;
}

/* 敬请期待 */
.expect-body {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1200;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.5);

  .ex-image {
    position: relative;
  }

  .ex-close {
    position: absolute;
    top: 10px;
    right: 10px;
    padding: 10px;
    font-size: 40px;
    line-height: 1;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue